import { Box, Grid } from '@mui/material'
import {
  Button,
  Card,
  DateRangePickerC,
  Form,
  // ResetButton,
  ResetFilters,
  SelectSeller
} from '../../../../components'
import { formatDate } from '../../../../utils'
import { existsFilters } from '../../../../utils/helpers'
import Yup from '../../../../utils/helpers/Yup'
import { useDebtsContext } from '../context/debtsReport.context'
import { debtsReport } from '../../../../services/api/Reports'
import { SelectCustomer } from 'modules/orders/components'

type FormValues = {
  customerId: {
    companyId: string
  } | null
  sellerId: {
    companyId: string
  } | null
  date: string[] | null[]
}

const debtsSchema = Yup.object({
  customerId: Yup.object({
    companyId: Yup.string().required()
  }).nullable(),
  sellerId: Yup.object({
    companyId: Yup.string().required()
  }).nullable(),
  date: Yup.mixed().test({
    name: 'dateRange',
    message: 'Deve conter data de início e fim!',
    test: (value) => {
      const isEmpty = value.every((e: any) => e === null)
      if (isEmpty) return isEmpty
      return value.every((e: any) => e !== null)
    }
  })
})

const defaultValues = {
  customerId: null,
  sellerId: null,
  date: [null, null]
}

const DebtsReportProvided = () => {
  const { filters, setFilters } = useDebtsContext()

  return (
    <div>
      <>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card
              sx={{
                display: 'flex',
                visibility: { xs: 'hidden', sm: 'hidden', md: 'visible' },
                flexDirection: 'row',
                gap: '10px',
                marginBottom: '20px'
              }}
            >
              <Box
                sx={{
                  visibility: { xs: 'visible', sm: 'visible', md: 'visible' },
                  width: '100%'
                }}
              >
                <DateRangePickerC
                  name="date"
                  inputFormat="dd/MM/yyyy"
                  startText="Data Inicial"
                  endText="Data Final"
                  sx={{ width: '100%' }}
                />
                <Box sx={{ marginTop: '1.25rem' }}>
                  <SelectCustomer />
                </Box>
                <Box sx={{ marginTop: '1.25rem' }}>
                  <SelectSeller />
                </Box>
              </Box>
            </Card>
            <Box
              sx={{
                display: 'flex',
                justifyContent: { sx: 'center', md: 'flex-end' },
                gap: '10px',
                marginTop: '1rem',
                width: '100%'
              }}
            >
              {existsFilters(filters) && (
                <ResetFilters onClick={() => setFilters({})} />
              )}
              {/* <ResetButton onClick={() => setFilters({})} /> */}
              <Button
                sx={{ width: { xs: '100%', md: 150 } }}
                form="debts-form"
                type="submit"
              >
                Emitir
              </Button>
            </Box>
          </Grid>
        </Grid>
      </>
    </div>
  )
}

export const DebtsReportForm = () => {
  const { setFilters } = useDebtsContext()

  const handleSubmit = async (data: FormValues) => {
    const normalizedData = {
      customerId: data?.customerId?.companyId,
      sellerId: data?.sellerId?.companyId,
      dateRange:
        data?.date.length === 2 && !data.date.some((e: any) => e === null)
          ? {
              startDate: data.date[0] && formatDate(new Date(data.date[0])),
              endDate: data.date[1] && formatDate(new Date(data.date[1]))
            }
          : undefined
    }

    setFilters(normalizedData)

    const urlPDF = await debtsReport({
      data: {
        startDate: normalizedData.dateRange?.startDate,
        endDate: normalizedData.dateRange?.endDate
      }
    })

    window.open(
      `${process.env.REACT_APP_API_URL + '/providers/media/' + urlPDF}`,
      '_blank'
    )
  }

  return (
    <Form<FormValues>
      id="debts-form"
      onSubmit={handleSubmit}
      schema={debtsSchema}
      options={{ defaultValues }}
    >
      <DebtsReportProvided />
    </Form>
  )
}
